import { z } from "zod/v4";

export const venuePhotoIdSchema = z.uuid().brand<"VenuePhotoId">();
export type VenuePhotoId = z.infer<typeof venuePhotoIdSchema>;

/** One venue-owned mini-site photo. A list's order is display order; the first is the cover. */
export const venuePhotoSchema = z.object({
	caption: z.string().nullable(),
	id: venuePhotoIdSchema,
	url: z.url(),
});
export type VenuePhoto = z.infer<typeof venuePhotoSchema>;

/** The venue service's photo rules (`photos/photo.rs`). The server stays the authority;
 * the portal mirrors them to refuse early and explain why. */
export const VENUE_PHOTO_RULES = {
	captionMax: 140,
	maxBytes: 10 * 1024 * 1024,
	maxCount: 12,
	types: ["image/jpeg", "image/png", "image/webp"],
} as const;
